import { onMounted, onUnmounted, onActivated, onDeactivated } from 'vue';

/**
 * 轮询 hook（自动处理生命周期，兼容 keep-alive 和非 keep-alive 场景）
 * @param {Function} queryTask - 轮询任务函数
 * @param {number} interval - 轮询间隔（毫秒）
 * @returns {{ startPolling: Function, stopPolling: Function }}
 */
export function usePolling(queryTask, interval = 60000) {
	let pollingTimeoutId = null;
	let isPolling = false;
	let justMounted = false;

	const startPolling = () => {
		if (!queryTask) return;
		stopPolling();
		isPolling = true;

		const executeFetch = async () => {
			if (!isPolling) return;

			try {
				await queryTask();
			} catch (error) {
				console.error('[Polling Error]', error);
			}

			if (isPolling) {
				pollingTimeoutId = setTimeout(executeFetch, interval);
			}
		};

		executeFetch();
	};

	const stopPolling = () => {
		isPolling = false;
		if (pollingTimeoutId) {
			clearTimeout(pollingTimeoutId);
			pollingTimeoutId = null;
		}
	};

	onMounted(() => {
		startPolling();
		justMounted = true;
	});

	onActivated(() => {
		if (justMounted) {
			justMounted = false;
			return;
		}
		startPolling();
	});

	onDeactivated(() => {
		stopPolling();
		justMounted = false;
	});

	onUnmounted(() => {
		stopPolling();
	});

	return { startPolling, stopPolling };
}
